export const assignmentConstants = {
  FETCH_DATA: 'FETCH_DATA',
  FETCH_FOOTNOTE: 'FETCH_FOOTNOTE',
  SET_ANSWER: 'ADD_ANSWER',
  SET_PAGE: 'SET_PAGE',
  SET_COMPONENT: 'SET_COMPONENT',
  ADD_ASSESS_ID: 'ADD_ASSESS_ID',
  ADD_DROPDOWN: 'ADD_DROPDOWN',
};
